import { defaultMoonriverProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/moonriver/default-constants';

export const SUSHI_SWAP_MOONRIVER_CONTRACT_ADDRESS = '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506';

export const SUSHI_SWAP_MOONRIVER_PROVIDER_CONFIGURATION = defaultMoonriverProviderConfiguration;
